// src/pages/Judge.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Navbar from '../components/Navbar';
import ApiService from '../services/apiService';

const Judge = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [searchIn, setSearchIn] = useState('J');
  const [spellingVar, setSpellingVar] = useState(false);
  const [searchType, setSearchType] = useState('E');

  useEffect(() => {
    document.body.style.paddingTop = '0';
  //  ApiService.logPageVisit('Judge/Advocate Search');
    const storedKeyword = localStorage.getItem('SearchHJudge');
    if (storedKeyword) setSearchQuery(storedKeyword);
    return () => { document.body.style.paddingTop = ''; };
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim() || isLoading) return;
  //  ApiService.logSearch('Judge', searchQuery.trim());
    setIsLoading(true);
    setError('');
    try {
      const searchOptions = { pageSize: 25, page: 1, sortBy: 'rele' };
      const isAdvocate = searchIn === 'A';
      const requestPayload = {
        judges: isAdvocate ? null : searchQuery,
        advocate: isAdvocate ? searchQuery : null,
        isExact: searchType === 'E',
        isSpellingVariation: spellingVar
      };
      const apiResponse = await ApiService.searchJudge(requestPayload, searchOptions);
      const searchResults = apiResponse.hits || [];
      if (searchResults.length === 0) {
        setError('No results found for your search query. Try different keywords.');
        setIsLoading(false);
        return;
      }
      const resultsData = {
        results: apiResponse.hits || [],
        totalCount: apiResponse.total || 0,
        query: '',
        searchType: 'Judge Search',
        isExact: searchType === 'E',
        isSpellingVariation: spellingVar,
        timestamp: new Date().toISOString(),
        courtsList: apiResponse.courtsList || [],
        yearList: apiResponse.yearList || [],
        searchData: {
          query: '',
          searchType: 'Judge Search',
          sortOrder: 'rele',
          searchIn,
          nearWordsDistance: '5'
        }
      };
      localStorage.setItem('searchResults', JSON.stringify(resultsData));
      localStorage.setItem('SearchHNominal', searchQuery);
      navigate('/results');
    } catch (error) {
      setError(error.message || 'Search failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setError('');
    localStorage.setItem('SearchHNominal', '');
  };

  return (
    <div className="gojuris-layout">
     
      <div className="gojuris-main">
        <Navbar />
        <div className="ai-search-page">
          {error && (
            <div className="error-alert">
              <i className="bx bx-error-circle"></i>
              {error}
            </div>
          )}

          <div className="ai-search-container">
            {/* Header Badge */}
            <div className="search-header">
              <div className="search-badge">
                <i className="bx bx-user-check"></i>
                <span>Judges / Advocates Search</span>
              </div>
            </div>

            {/* Hero */}
            <div className="search-hero">
              <h1 className="hero-title">
                Find judgments by Judge or Advocate name — fast and precise
              </h1>

              {/* Search Box */}
              <div className="search-container">
                <form onSubmit={handleSearch} className="search-form">
                  <div className="search-input-wrapper">
                    <input
                      type="text"
                      className="search-input"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Type any Judge or Advocate name in full or partial..."
                      disabled={isLoading}
                    />
                    <div className="input-actions">
                      {searchQuery.length > 0 && (
                        <button
                          type="button"
                          className="voice-btn"
                          onClick={handleClearSearch}
                          disabled={isLoading}
                        >
                          <i style={{ fontSize: '25px' }} className="bx bx-x"></i>
                        </button>
                      )}
                      <button
                        type="submit"
                        className="search-btn"
                        disabled={isLoading || !searchQuery.trim()}
                      >
                        {isLoading ? (
                          <i className="bx bx-loader bx-spin" style={{ fontSize: '24px', color: '#E91E63' }}></i>
                        ) : (
                          <img src="/Images/i-search.png" alt="Search" className="search-icon-img" />
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              {/* Search Options */}
              <div className="search-options-below">
                <div className="radio-group search-in-group">
                  <span className="group-label">Search in:</span>
                  <label className="radio-label">
                    <input type="radio" name="searchIn" value="J"
                      checked={searchIn === 'J'} onChange={(e) => setSearchIn(e.target.value)} />
                    <span className="radio-mark"></span>
                    Judge
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="searchIn" value="A"
                      checked={searchIn === 'A'} onChange={(e) => setSearchIn(e.target.value)} />
                    <span className="radio-mark"></span>
                    Advocates
                  </label>
                </div>

                <div className="radio-group search-in-group">
                  <span className="group-label">Search Type:</span>
                  <label className="radio-label">
                    <input type="radio" name="searchType" value="E"
                      checked={searchType === 'E'} onChange={(e) => setSearchType(e.target.value)} />
                    <span className="radio-mark"></span>
                    Exact
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="searchType" value="F"
                      checked={searchType === 'F'} onChange={(e) => setSearchType(e.target.value)} />
                    <span className="radio-mark"></span>
                    Free
                  </label>
                  <label className="radio-label">
                    <input type="checkbox" name="spellingVar" checked={spellingVar}
                      onChange={() => setSpellingVar(!spellingVar)} />
                    <span className="checkbox-mark"></span>
                    Spelling Variations
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .gojuris-layout { display: flex; min-height: 100vh; }

        .gojuris-main {
          flex: 1;
          margin-left: 70px;
          width: calc(100% - 70px);
          background: #f8f9fa;
          min-height: 100vh;
        }

        .ai-search-page {
          min-height: calc(100vh - 80px);
          background: #f8f9fa;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
        }

        .ai-search-container {
          max-width: 1200px;
          width: 100%;
          margin-top: -100px;
          text-align: center;
        }

        .error-alert {
          background: #f8d7da;
          color: #721c24;
          padding: 1rem;
          border-radius: 8px;
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          justify-content: center;
        }

        .search-header { margin-bottom: 3rem; }

        /* ✅ Badge - Orange theme */
        .search-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1.5rem;
          background: white;
          border: 1px solid rgba(245, 166, 35, 0.3);
          border-radius: 25px;
          background: linear-gradient(135deg, rgba(245,166,35,0.08), rgba(233,30,99,0.08));
          color: #E91E63;
          font-weight: 600;
          font-size: 14px;
          box-shadow: 0 2px 8px rgba(245, 166, 35, 0.15);
        }
        .search-badge i { font-size: 16px; }

        .search-hero { margin-bottom: 4rem; }

        .hero-title {
          font-size: clamp(1.6rem, 4vw, 2rem);
          font-weight: 300;
          color: #333;
          line-height: 1.3;
          margin-bottom: 2rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .search-container { max-width: 1100px; margin: 0 auto; }
        .search-form { width: 100%; }

        /* ✅ Input border - Orange theme */
        .search-input-wrapper {
          position: relative;
          background: white;
          border-radius: 50px;
          border: 2px solid #E91E63;
          padding: 8px;
          box-shadow: 0 4px 20px rgba(245, 166, 35, 0.15);
          display: flex;
          align-items: center;
          gap: 8px;
          transition: box-shadow 0.3s ease;
        }
        .search-input-wrapper:focus-within {
          box-shadow: 0 4px 25px rgba(245, 166, 35, 0.3);
          border-color: #c41849;
        }

        .search-input {
          flex: 1;
          border: none;
          background: transparent;
          padding: 1rem 1.5rem;
          font-size: 18px;
          outline: none;
          color: #333;
        }
        .search-input::placeholder { color: #999; }

        .input-actions { display: flex; align-items: center; gap: 8px; }

        .voice-btn {
          width: 40px; height: 40px;
          border: none; background: transparent;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; color: #6c757d;
          transition: all 0.2s ease;
        }
        .voice-btn:hover:not(:disabled) { background: #fff5e6; color: #E91E63; }

        .search-btn {
          width: 48px; height: 48px;
          border: none; background: #ffffff;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.2s ease;
        }
        .search-btn:hover:not(:disabled) { transform: scale(1.05); }
        .search-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .search-icon-img { width: 50px; height: 50px; object-fit: contain; }

        /* ✅ Radio / checkbox options */
        .search-options-below { margin: 1rem 0; }

        .radio-group {
          display: flex; flex-wrap: wrap;
          gap: 1rem; justify-content: center; align-items: center;
          margin: 0.5rem 0;
        }

        .search-in-group {
          border-top: 1px solid #f0e6d3;
          padding-top: 1rem; margin-top: 1rem;
        }

        .group-label { font-weight: 600; color: #374151; margin-right: 1rem; }

        .radio-label {
          display: flex; align-items: center; gap: 0.5rem;
          cursor: pointer; font-size: 0.875rem; color: #374151;
          user-select: none; padding: 0.25rem 0.75rem;
          border-radius: 20px; transition: all 0.2s ease;
        }
        .radio-label:hover { background: rgba(245, 166, 35, 0.08); }

        .radio-label input[type="radio"],
        .radio-label input[type="checkbox"] {
          width: 18px; height: 18px; margin: 0;
          opacity: 0; position: absolute; z-index: -1;
        }

        .radio-mark {
          width: 18px; height: 18px;
          border: 2px solid #d1d5db; border-radius: 50%;
          background: white; transition: all 0.2s ease;
          position: relative; display: inline-block; flex-shrink: 0;
        }
        .radio-label:hover .radio-mark { border-color: #E91E63; }
        .radio-label input[type="radio"]:checked + .radio-mark { border-color: #E91E63; }
        .radio-label input[type="radio"]:checked + .radio-mark::after {
          content: '';
          position: absolute;
          width: 8px; height: 8px;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-radius: 50%;
          top: 3px; left: 3px;
        }

        .checkbox-mark {
          width: 18px; height: 18px;
          border: 2px solid #d1d5db; border-radius: 4px;
          background: white; transition: all 0.2s ease;
          position: relative; display: inline-block; flex-shrink: 0;
        }
        .radio-label:hover .checkbox-mark { border-color: #E91E63; }
        .radio-label input[type="checkbox"]:checked + .checkbox-mark {
          background: linear-gradient(135deg, #E91E63, #c41849);
          border-color: #E91E63;
        }
        .radio-label input[type="checkbox"]:checked + .checkbox-mark::after {
          content: '✓';
          position: absolute;
          color: white; font-size: 12px; font-weight: 700;
          top: -1px; left: 2px;
        }

        @media (max-width: 768px) {
          .ai-search-page { padding: 1rem 0.5rem; }
          .search-input { padding: 0.75rem 1rem; font-size: 14px; }
          .search-icon-img { width: 32px; height: 32px; }
          .radio-group { flex-direction: column; align-items: flex-start; }
          .group-label { margin-right: 0; margin-bottom: 0.5rem; }
        }

        @media (max-width: 575.98px) {
          .gojuris-main { margin-left: 60px; width: calc(100% - 60px); }
        }
      `}</style>
    </div>
  );
};

export default Judge;